import {
  faChartColumn,
  faSignal,
  faFile,
  faBullhorn,
  faHome,
  faEuro
} from "@fortawesome/free-solid-svg-icons";
import { tt } from "../../../utils/i18n/i18n";
import {
  BILLS,
  JETPACK_CONFIG,
  ANALYTICS,
  POSA,
  MONTHLY_STATS,
  FORM_DATA
} from "../../../utils/routes/routes";
import { type LinkI } from "./types";

export const links: LinkI[] = [
  {
    path: JETPACK_CONFIG,
    text: tt("dashboard_detail"),
    icon: faHome,
    useTrackingID: true
  },
  {
    path: ANALYTICS,
    text: tt("dashboard"),
    icon: faChartColumn,
    useTrackingID: true
  },
  {
    path: MONTHLY_STATS,
    text: tt("monthly_statistics"),
    icon: faEuro,
    useTrackingID: true
  },
  // {
  //   path: COLORTEST,
  //   text: "Test couleurs",
  //   icon: faMicroscope
  // },
  // {
  //   path: VOUCHERS,
  //   text: tt("vouchers"),
  //   icon: faHandHoldingDollar
  // },
  {
    path: FORM_DATA,
    text: tt("data"),
    icon: faSignal,
    useTrackingID: true
  },
  // {
  //   path: EMAILS_NUMBERS,
  //   text: tt("emails_and_numbers"),
  //   icon: faEnvelope
  // },
  {
    path: POSA,
    text: tt("posa_short"),
    icon: faBullhorn,
    useTrackingID: true
  },
  {
    path: BILLS,
    text: tt("invoices"),
    icon: faFile,
    useTrackingID: true
  }
  // {
  //   path: CONTACT,
  //   text: tt("contact"),
  //   icon: faQuestion
  // }
];
